"use client";
import { createContext } from "react";
//#region packages/@mantine/core/src/components/Menu/MenuCheckboxGroup/MenuCheckboxGroup.context.tsx
const MenuCheckboxGroupContext = createContext(null);
//#endregion
export { MenuCheckboxGroupContext };

//# sourceMappingURL=MenuCheckboxGroup.context.mjs.map